//------------------------------------------------------------------------------
// 表示専用フィールド
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';

/**
 * 表示専用フィールド (非フォーム項目)
 */
function DisplayField({
  label,
  value,
  required,
  placeholder,
  ...moreProps
}) {
  placeholder = placeholder || '入力不可';
  return (
    <TextField label={label}
      value={value ?? ''}
      variant="standard"
      fullWidth={true} size="small"
      required={required}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        readOnly: true,
        placeholder: placeholder,
      }}
      {...moreProps}
    />
  );
}

// 表示専用フィールドプロパティ
DisplayField.propTypes = {
  label:       PropTypes.string,    // ラベル
  value:       PropTypes.string,    // 表示値
  required:    PropTypes.bool,      // 必須有無
  placeholder: PropTypes.string,    // プレースホルダー
};

// デフォルトエクスポート
export default DisplayField;
